import {HTTP} from "../../_helpers/http";
import {config} from "@shared/_services/config";

export default class TemplateApi {

    static get() {
        return HTTP.get(config.contentApi.template)
            .then(response => response.data)
    }

    static add(template) {
        return HTTP.post(config.contentApi.template, template)
            .then(response => response.data)
    }

    static delete(templateId) {
        return HTTP.delete(`${config.contentApi.template}/${templateId}`)
            .then(response => response.data)
    }

}